import { createFileRoute } from '@tanstack/react-router'
import WorkOverview from 'Work/components/Work/Sections/Overview/WorkOverview'

export const Route = createFileRoute('/work/$workId/')({
    component: WorkOverview,
})
